import ApiClient from './ApiClient';

class CampaignsV2API extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  trigger(campaignId) {
    return axios.post(`${this.url}/${campaignId}/trigger`);
  }

  analytics(campaignId) {
    return axios.get(`${this.url}/${campaignId}/analytics`);
  }

  exportCampaign(campaignId) {
    return axios.post(`${this.url}/${campaignId}/export`);
  }

  uploadMedia(campaignId, formData) {
    return axios.post(`${this.url}/${campaignId}/upload_media`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  getExecutions(campaignId) {
    return axios.get(`${this.url}/${campaignId}/campaign_executions`);
  }

  getExecution(campaignId, executionId) {
    return axios.get(
      `${this.url}/${campaignId}/campaign_executions/${executionId}`
    );
  }

  getExecutionMessages(campaignId, executionId, params = {}) {
    return axios.get(
      `${this.url}/${campaignId}/campaign_executions/${executionId}/campaign_messages`,
      { params }
    );
  }
}

export default new CampaignsV2API();
